import home from './default.png';
import homeFocused from './defaultFocused.png';
import trash from './delete.png';
import trashFocused from './deleteFocused.png';
import edit from './edit.png';
import editFocused from './editFocused.png';

export const editIcons = {
  home,
  homeFocused,
  trash,
  trashFocused,
  edit,
  editFocused,
};
